import { useState } from "react";
import classNames from "classnames";
import { ArrowIcon } from "@shared/ui/Icon/ui/Common/arrow-icon";
import { TableOfContentProps } from "./types";
import classes from "./table-of-content.module.scss";

export const TableOfContent = ({ items }: TableOfContentProps) => {
    const [isOpen, setIsOpen] = useState(true);
    const isEmptyTable = !items || items.length === 0;

    return isEmptyTable ? null : (
        <nav className={classes["table-of-content"]}>
            <button
                className={classes["table-of-content__header"]}
                onClick={() => setIsOpen((prev) => !prev)}
                aria-expanded={isOpen}
                type="button"
            >
                <strong className={classes["table-of-content__name"]}>Содержание</strong>
                <ArrowIcon
                    className={classNames(
                        classes["table-of-content__arrow"],
                        isOpen && classes["table-of-content__arrow--rotated"]
                    )}
                />
            </button>
            <ul
                className={classNames(classes["table-of-content__list"], {
                    [classes["table-of-content__list--collapsed"]]: !isOpen
                })}
            >
                {items.map(({ id, text, level }) => (
                    <li
                        key={id}
                        className={classNames(classes["table-of-content__item"], {
                            [classes["table-of-content__item--nested"]]: level === 3,
                            [classes["table-of-content__item--subnested"]]: level === 4
                        })}
                    >
                        <a className={classes["table-of-content__link"]} href={`#${id}`}>
                            {text}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};